import React from "react";
import { Row, Col } from "reactstrap";

/** Gradient banner used at the top of the portfolio-wide manager pages. */
const PageHero = ({ title, subtitle, children }) => (
  <div
    className="rounded mb-4 p-4 text-white position-relative overflow-hidden"
    style={{ minHeight: 140 }}
  >
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: "linear-gradient(135deg, #4f46e5 0%, #34c38f 100%)",
      }}
    />
    <div className="position-relative" style={{ zIndex: 1 }}>
      <Row className="align-items-center">
        <Col>
          <h3 className="mb-1 text-white">{title}</h3>
          <p className="mb-0 opacity-75">{subtitle}</p>
        </Col>
        {children && <Col xs="auto">{children}</Col>}
      </Row>
    </div>
  </div>
);

export default PageHero;
